import React, { useState } from 'react'
import styles from '../../styles/front/search_page/SearchForm.module.sass'
import AutoResizeText from './AutoResizeText'

type SearchFormProps = {
  shop_id: string[],
  stores: any[],
  theme_color: string
}

const SearchForm = (props: SearchFormProps) => {
  const {
    shop_id,
    stores,
  } = props

  const theme_color = '-' + props.theme_color;
  const [isShowCategory, setIsShowCategory] = useState<boolean>(false)

  function clickSelectTargetTag(id: string) {
    location.href = `${location.origin}/staffs/${id}`
  }

  function clickCategoryBtn() {
    if(!isShowCategory) setIsShowCategory(true)
  }

  return (
    <>
      {(stores.length > 1) && (
        <div>
          <div className={`${styles.searchForm} ${styles.staffs}`}>
            <div className={styles.searchFormContainer}>
              {/* pcで表示 */}
              {stores.length > 1 && (
                <div className={`${styles.searchWordsTop} ${styles.staffs} ${ stores.length <= 3 ? styles.center : ""}`}>
                  {stores.map((store) => (
                    <div
                      key={store.id}
                      className={`${styles.searchWordBtn} ${styles.staff} ${shop_id == store.id || shop_id === store.japanese_id ? styles[theme_color] : styles.normal + " " + styles[theme_color] + " " + styles['-primary-light']}`}
                      onClick={() => clickSelectTargetTag(store.id)}
                    >
                      <AutoResizeText text={store.name} />
                    </div>
                  ))}
                </div>
              )}
              {/* spで表示 */}
              {stores.length > 1 && (
                <div className={`${styles.categoryBtn} ${styles.staffCategoryBtn} ${styles[theme_color]}`} onClick={clickCategoryBtn}>
                  店舗で絞り込む
                  {!isShowCategory && (
                    <div className={styles.categoryLineArrow}>
                      <div className={styles.line}></div>
                      <div className={styles.arrow}></div>
                  </div>
                  )}
                  {isShowCategory && (
                    <div className={`${styles.close} ${styles.categoryClose}`} onClick={() => setIsShowCategory(false)}>clear</div>
                  )}
                  {isShowCategory && (
                    <div className={styles.spCategoryList}>
                      {stores.map((store) => (
                        <div
                          key={store.id}
                          className={styles.spCategory}
                          onClick={() => clickSelectTargetTag(store.id)}
                        >
                          <div className={styles.spCategoryText}> 
                            <AutoResizeText text={store.name} />
                          </div>
                          <div className={styles.lineArrow}>
                            <div className={styles.line}></div>
                            <div className={styles.arrow}></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SearchForm
